import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// =============================================================================
// Kiosk zoom-lock — three layers, because iOS Safari ignores any one of them
// individually:
//   1. <meta viewport user-scalable=no maximum-scale=1.0> in index.html
//   2. CSS touch-action: pan-y on html/body in index.css
//   3. JS event listeners below — block iOS Safari's gesturestart events
//      (which is how pinch-zoom is delivered when CSS doesn't catch it),
//      block double-tap zoom by suppressing the synthetic dblclick, and
//      block Ctrl+wheel zoom for iPads docked with a Magic Keyboard.
// =============================================================================

// (1) iOS pinch-zoom is delivered via the non-standard `gesturestart`,
//     `gesturechange`, `gestureend` events. Preventing the first one
//     stops the gesture from kicking in. No-op on browsers that don't
//     fire these events.
['gesturestart', 'gesturechange', 'gestureend'].forEach((ev) => {
  document.addEventListener(ev, (e) => e.preventDefault(), { passive: false });
});

// (2) Double-tap zoom — iOS fires a synthetic dblclick after two quick taps
//     on elements that aren't touch-action: manipulation. The body's
//     touch-action: pan-y catches most of it; this is belt-and-braces.
document.addEventListener('dblclick', (e) => e.preventDefault(), { passive: false });

// (3) Ctrl+wheel zoom (Magic Keyboard / Smart Keyboard Folio with trackpad).
document.addEventListener(
  'wheel',
  (e) => {
    if (e.ctrlKey) e.preventDefault();
  },
  { passive: false }
);

// (4) Cmd / Ctrl ± keyboard shortcuts.
document.addEventListener('keydown', (e) => {
  if ((e.metaKey || e.ctrlKey) && ['+', '-', '=', '0'].includes(e.key)) {
    e.preventDefault();
  }
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
